var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"chart"},[_c('chart-pie',{attrs:{"data-list":_vm.pieData,"extra-option":_vm.option}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }